<template lang="pug">
  div(class="dynamic-toolbar document-state")
    span(class="text-14px fw-500 errored") *
    span(class="text-12px fw-300 white-text") {{ $t('Required field') }}
</template>

<script>
export default {
  name: 'BlockDocumentFieldToolbar'
}
</script>

<style scoped lang="scss"></style>
